var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 250 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FDF2F8",
  fillRule: "evenodd",
  d: "M63 134h91q.774-.002 1.5-.161.726.16 1.5.161h52a7 7 0 1 0 0-14h-6a7 7 0 1 1 0-14h19a7 7 0 1 0 0-14h-22a7 7 0 1 0 0-14h-64a7 7 0 1 0 0-14H79a7 7 0 1 0 0 14H39a7 7 0 1 0 0 14h25a7 7 0 1 1 0 14H24a7 7 0 1 0 0 14h39a7 7 0 1 0 0 14m163 0a7 7 0 1 0 0-14 7 7 0 0 0 0 14",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BE185D",
  fillRule: "evenodd",
  d: "M104 142.611h16.561l-8.675 27.602 38.644-39.036h-23.266L140.277 74z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M92 124c-12.15 0-22-9.626-22-21.5S79.85 81 92 81q.776 0 1.537.052A34 34 0 0 1 93 75c0-18.778 15.222-34 34-34 14.991 0 27.716 9.702 32.239 23.17A31 31 0 0 1 162.5 64c16.845 0 30.5 13.432 30.5 30 0 15.741-12.325 28.727-28 29.978V124H92m11.996 0h-6.965z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#960145",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M103.996 124h-6.965M92 124c-12.15 0-22-9.626-22-21.5S79.85 81 92 81q.776 0 1.537.052A34 34 0 0 1 93 75c0-18.778 15.222-34 34-34 14.991 0 27.716 9.702 32.239 23.17A31 31 0 0 1 162.5 64c16.845 0 30.5 13.432 30.5 30 0 15.741-12.325 28.727-28 29.978V124H92Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeOpacity: 0.2,
  strokeWidth: 3,
  d: "M103.996 124h-6.965M92 124c-12.15 0-22-9.626-22-21.5S79.85 81 92 81q.776 0 1.537.052A34 34 0 0 1 93 75c0-18.778 15.222-34 34-34 14.991 0 27.716 9.702 32.239 23.17A31 31 0 0 1 162.5 64c16.845 0 30.5 13.432 30.5 30 0 15.741-12.325 28.727-28 29.978V124H92Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FDF2F8",
  fillRule: "evenodd",
  d: "M116.612 48.343c0 32.223 29.021 58.775 66.388 62.36-4.683 5.758-11.914 9.664-20.153 10.278V121H95.743C87.601 121 74 117.57 74 102.548c0-15.021 10.574-18.451 21.743-18.451q.713 0 1.413.044c-.324-1.685-.381-3.423-.494-5.194-.758-11.963 4.461-27.04 19.968-31.947q-.018.67-.018 1.343",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BE185D",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M137 51a19.04 19.04 0 0 1 13.44 13.293"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BE185D",
  strokeWidth: 2,
  d: "M158 34a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#BE185D",
  d: "M189 50a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BE185D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "m165.757 41.757 8.359 8.359m.127-8.359-8.359 8.359zM71.404 59.596l6 6m0-6-6 6z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#BE185D",
  d: "M85 53a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
})));
export default SvgError;